import React from 'react';
import styled from 'styled-components';

import { Tooltip } from '@shared/Tooltip';
import { BLUE_GREY, NOTES_COLOR, PALE_GREY } from '../../../theme';
import LockIcon from '../../../images/icon-lock.inline.svg';
import QuestionIcon from '../../../images/icon-question.inline.svg';
import { isMobile } from '../../../constants';
import media from '../../../utils/mediaQueries';
import StripeIcon from '../../../images/icon-stripe.inline.svg';
import mastercard from '../../../images/mastercard.svg';
import visa from '../../../images/visa.svg';
import cb from '../../../images/cb.svg';

const Badge = styled.div`
  border-radius: 10px;
  background-color: ${PALE_GREY};
  padding: 8px 12px 9px;
  display: flex;
  align-items: flex-start;
`;

const LockIconContainer = styled.div`
  width: 24px;
  flex: 0 0 24px;
`;

const Lock = styled(LockIcon)`
  width: 12px;
  height: 16px;
`;

const BadgeContent = styled.div`
  width: 100%;
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: -0.1px;
`;

const QuestionIconContainer = styled.div`
  width: 20px;
  flex: 0 0 20px;
  align-self: flex-end;
`;

const Question = styled(QuestionIcon)`
  fill: ${BLUE_GREY};
  width: 16px;
  height: 16px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 24px;
  
  ${media.mobile`
    flex-direction: column;
    align-items: center;
  `}
`;

const StripeLogoCol = styled.div`
  display: flex;
  align-items: center;
`;

const StripeLogo = styled(StripeIcon)`
  width: 110px;
  height: 24px;
`;

const StripeLogoCaption = styled.span`
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: ${NOTES_COLOR};
  margin-left: 12px;
  
  ${media.mobile`
    font-size: 10px;
    line-height: 1.2;
  `}
`;

const PaymentLogosCol = styled.div`
  display: flex;
  justify-content: flex-start;
  
  ${media.mobile`
    margin-top: 16px;
  `}
`;

const PaymentIcon = styled.img`
  width: 35px;
  
  &+& {
    margin-left: 6px;
  }
`;

const StripeInfo = () => (
  <div>
    <Badge>
      <LockIconContainer><Lock /></LockIconContainer>
      <BadgeContent>Vos informations bancaires sont cryptées et traitées directement par Stripe, leader du paiement sécurisé en ligne.</BadgeContent>
      <QuestionIconContainer>
        <Tooltip
          position={isMobile ? 'bottom right' : 'right center'}
          trigger={isMobile ? 'click' : 'hover'}
          content="Aucune donnée n’est reçue ni stockée par vroomvroom.fr. Connexion directe entre votre ordinateur et la banque."
          width={200}
        >
          <Question />
        </Tooltip>
      </QuestionIconContainer>
    </Badge>
    <Footer>
      <StripeLogoCol>
        <StripeLogo />
        <StripeLogoCaption>Connexion sécurisée SSL</StripeLogoCaption>
      </StripeLogoCol>
      <PaymentLogosCol>
        <PaymentIcon src={mastercard} alt="Mastercard icon" />
        <PaymentIcon src={visa} alt="Visa icon" />
        <PaymentIcon src={cb} alt="CB icon" />
      </PaymentLogosCol>
    </Footer>
  </div>
);

export { StripeInfo };
